import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  meta: {
    pageNumber: 1,
    pageSize: 20,
    itemTotal: 0,
  },
  list: [],
  reports: [],
  selectedRequiredDoc: {},
  requiredDocAdded: false,
  requiredDocUpdated: false,
  requiredDocRemoved: false,
};

const proposalRequiredDocSlice = createSlice({
  name: "proposalRequiredDoc",
  initialState,
  reducers: {
    getProposalRequiredDocs(state, action) {
      state.list = action.payload.requireDocuments;
      state.meta = action.payload.meta;
    },
    getProposalRequiredDocById(state, action) {
      state.selectedRequiredDoc = action.payload;
    },
    addFeeProposal(state, action) {
      state.requiredDocAdded = true;
    },
    updateFeeProposal(state, action) {
      state.requiredDocUpdated = true;
    },
    removeFeeProposal(state, action) {
      state.requiredDocRemoved = true;
    },
    reset: (state) => initialState,
    logout: (state) => initialState,
  },
});

export const proposalRequiredDocActions = proposalRequiredDocSlice.actions;
export default proposalRequiredDocSlice;
